import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { PartnerDetail } from 'app/models/partner-detail';
import { CommonRequestResponseService, NotificationService } from 'app/services';
import * as inputMasker from 'vanilla-masker';
import { WebService } from './../../services/web.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {
  contactForm: FormGroup;
  partnerDetail: PartnerDetail;
  partnerId: string;              // needed?
  coachingHours: any;
  partnerLogo: string;
  constructor(
    private fb: FormBuilder,
    private commonRequestResponseService: CommonRequestResponseService,
    private notificationService: NotificationService,
    private router: Router,
    private webService: WebService,

  ) { }

  ngOnInit() {
    this.contactForm = this.fb.group({
      ClientNumber: ['', [Validators.compose([Validators.required])]],
      Name: ['', [Validators.compose([Validators.required])]],
      Email: ['', [Validators.compose([Validators.required, Validators.email])]],
      Phone: ['', [Validators.compose([Validators.required])]],
      Message: ['', [Validators.compose([Validators.required])]],
    });

    const partnerDetail = JSON.parse(localStorage.getItem('partnerDetail'));
    if (partnerDetail) {
      this.partnerDetail = partnerDetail;
      this.partnerLogo = JSON.parse(localStorage.getItem('partnerDetail')).partnerLogo || './assets/img/envision_logo.png';
    }

    const userProfile = this.createUserProfile(this.partnerDetail && this.partnerDetail.partnerId ? this.partnerDetail.partnerId : '');
    this.getCoachingHours(userProfile);

  }

  createUserProfile(partnerId) {
    const data = this.commonRequestResponseService.setUserDetailAPI({ partnerId: partnerId }, ['partnerId']);
    return data;
  }

  getCoachingHours(userProfile) {
    this.webService.post('admin/getoperatingHours', userProfile)
      .subscribe(
        response => {
          this.coachingHours = response.message;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching coaching hours');
        });
  }

  get cf(): any {
    return this.contactForm.controls;
  }

  onSubmit(): void {
    if (this.contactForm.invalid) {
      this.notificationService.show('info', 'Please fill out all the fields');
      return;
    }

    const jsonInput = {
      PartnerId: this.partnerDetail && this.partnerDetail.partnerId ? this.partnerDetail.partnerId : '',
      ...this.contactForm.value,
    };

    this.commonRequestResponseService.postWithHeader('/Shared/SendContactUsEmail', jsonInput).subscribe(
      () => {
        this.notificationService.show('success', 'Thank you for contacting us');
        this.router.navigate(['/']);
      },
      () => {
        this.notificationService.show('error', 'An error occurs while submitting the form');
      }
    );
  }

  phoneNumberMask() {
    // Converts value to masked phone
    const maskedPhoneValue = this.maskValue(this.contactForm.get('Phone').value);
    this.contactForm.patchValue({ Phone: maskedPhoneValue });
  }

  private maskValue(value: any) {
    return inputMasker.toPattern(value, '(999) 999-9999');
  }
}
